import React from "react";
import { Box, ScrollArea, Stack, Title, TextInput, Divider } from "@mantine/core";
import MCTemplateSelectChecklist from "./MCTemplateSelectChecklist";
import SingleMcTemplate from "./SingleMcTemplate";
import ChecklistExcelImportTest from "./ChecklistExcelImportTest";
import CreateChecklistTemplateButton from "./MCCreateChecklistTemplateModal";
import ProjectTemplateSelectChecklist from "./ProjectTemplateSelectChecklist";
import { useAppDispatch, useAppSelector } from "../hooks";
import { setXApiKeyInRedux } from "../global/globalSlice";
import { GenerateChecklistForm } from "./GenerateChecklistForm";
import { ChecklistsByReviewId } from "./ChecklistsByReviewId";

const ChecklistTemplateTestPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const xApiKey = useAppSelector((state) => state.globalReducer.xApiKey);

  return (
    <ScrollArea h="100vh" type="auto" offsetScrollbars>
      <Box
        p="md"
        sx={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4e9f0 100%)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
        }}
      >
        <Title order={4} mb="md">
          Testside for sjekklistemaler
        </Title>

        <Stack>
          <TextInput
            label="x-api-key"
            placeholder="Lim inn API-nøkkel"
            value={xApiKey ?? ""}
            onChange={(e) =>
              dispatch(setXApiKeyInRedux(e.currentTarget.value.length > 0 ? e.currentTarget.value : null))
            }
          />
          {xApiKey != null && (
            <>
              <Divider />
              <ProjectTemplateSelectChecklist />
              <Divider />
              <CreateChecklistTemplateButton />
              <Divider />
              <ChecklistExcelImportTest />
              <Divider />
              <MCTemplateSelectChecklist />
              <Divider />
              <SingleMcTemplate />
              <Divider />
              <ChecklistsByReviewId />
              <Divider />
              <GenerateChecklistForm />
            </>
          )}
        </Stack>
      </Box>
    </ScrollArea>
  );
};

export default ChecklistTemplateTestPage;
